import { useEffect, useState } from 'react'
import Button from '@mui/material/Button'

import Grid from '@mui/material/Grid'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'

import {
  Alert,
  DialogActions,
  DialogContent,
  MenuItem,
  TextField
} from '@mui/material'
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter'
import HeightIcon from '@mui/icons-material/Height'
import WcIcon from '@mui/icons-material/Wc'

const css = {
  label: {
    '& label': {
      width: '100%',
      display: 'flex',
      paddingRight: '20px',
      justifyContent: 'space-between'
    }
  },
  input: {
    '& input[type=text]': {
      padding: '1.6em 0.75em 0.75em',
      textAlign: 'center'
    },
    '& input[type=number]': {
      padding: '1.6em 0.75em 0.5em',
      textAlign: 'center',
      maxWidth: '100%',
      minHeight: '54px',
    }
  }
}
const { femme_imcMax, femme_poidsMax, homme_imcMax, homme_poidsMax } =
  window.variables
const imc = (poids, taille) => {
  const newTaille = +taille / 100
  return +poids / (newTaille * newTaille)
}
const messages = (type, sexe, poids, taille) => {
  switch (type) {
    case 'info':
      return {
        type: 'info',
        text: `Pour un${
          sexe === 'homme' ? ' homme' : 'e femme'
        } de ${poids} kg, mesurant ${taille / 100} m, l'IMC est de ${
          Math.round(imc(poids, taille) * 100) / 100
        }`
      }

    case 'imcError':
      return {
        type: 'error',
        text: `Désolé mais vous êtes au dessus de la limitation d'IMC : ${
          sexe === 'homme' ? homme_imcMax : femme_imcMax
        }`
      }

    case 'poidsError':
      return {
        type: 'error',
        text: `Désolé mais vous êtes au dessus de la limitation de poids : ${
          sexe === 'homme' ? homme_poidsMax : femme_poidsMax
        }`
      }

    default:
      return {
        type: 'success',
        text: `Préparez-vous pour votre aventure !!!`
      }
  }
}

function SimpleDialog({ open, onClose }) {
  // const { onClose, selectedValue, open } = props
  const [sexe, setSexe] = useState('')
  const [poids, setPoids] = useState('')
  const [taille, setTaille] = useState('')
  const [message, setMessage] = useState([])
  useEffect(() => {
    const msg = []
    if ((sexe, poids, taille)) {
      switch (sexe) {
        case 'homme':
          msg.push(messages('info', sexe, poids, taille))
          if (imc(poids, taille) > +homme_imcMax) {
            msg.push(messages('imcError', sexe, poids, taille))
          }
          if (+poids > +homme_poidsMax) {
            msg.push(messages('poidsError', sexe, poids, taille))
          }
          if (msg.length === 1) {
            msg.push(messages('valid', sexe, poids, taille))
          }
          break
        case 'femme':
          msg.push(messages('info', sexe, poids, taille))
          if (imc(poids, taille) > +femme_imcMax) {
            msg.push(messages('imcError', sexe, poids, taille))
          }
          if (+poids > +femme_poidsMax) {
            msg.push(messages('poidsError', sexe, poids, taille))
          }
          if (msg.length === 1) {
            msg.push(messages('valid', sexe, poids, taille))
          }
          break

        default:
          break
      }
      setMessage(msg)
    }
  }, [sexe, poids, taille])
  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog onClose={handleClose} open={open} fullWidth>
      <DialogTitle>Testez votre IMC</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            {/* <InputLabel id='sexe'>Vous êtes</InputLabel> */}
            <TextField
              select
              fullWidth
              variant='filled'
              margin='dense'
              labelId='sexe'
              displayEmpty
              sx={{
                margin: 0,
                ...css.input,
                ...css.label
              }}
              id='sexe'
              value={sexe}
              label={
                <>
                  <WcIcon /> Sexe
                </>
              }
              onChange={(e) => {
                setSexe(e.target.value)
              }}>
              <MenuItem value='femme'>Une femme</MenuItem>
              <MenuItem value='homme'>Un homme</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="number"
              sx={{
                height: '100%',
                ...css.input,
                ...css.label
              }}
              variant='filled'
              id='poids'
              value={poids}
              label={
                <>
                  <FitnessCenterIcon /> Poids en kg
                </>
              }
              onChange={(e) => {
                setPoids(e.target.value)
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              xs={12} 
              fullWidth
              type="number"
              sx={{
                height: '100%',
                ...css.input,
                ...css.label
              }}
              variant='filled'
              id='taille'
              value={taille}
              label={
                <>
                  <HeightIcon />
                  Taille en cm
                </>
              }
              onChange={(e) => {
                setTaille(e.target.value)
              }}
            />
          </Grid>
          {message &&
            message.map((msg, i) => (
              <Grid key={i} item sm={12}>
                {msg.type === 'error' && (
                  <Alert severity='error'>{msg.text}</Alert>
                )}
                {msg.type === 'info' && (
                  <Alert severity='info'>{msg.text}</Alert>
                )}
                {msg.type === 'success' && (
                  <Alert severity='success'>{msg.text}</Alert>
                )}
              </Grid>
            ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default function Modal() {
  const [open, setOpen] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <Button variant='contained' onClick={handleClickOpen}>
        Testez votre IMC
      </Button>
      <SimpleDialog open={open} onClose={handleClose} />
    </div>
  )
}
